import { AddressViewModel } from './AddressViewModel';
import { FTDate } from './FTDate';
import { IndividualNameViewModel } from './IndividualNameViewModel';
import { MultiMediaBasicInfo } from './MultiMediaBasicInfo';

export class MemberViewModel{
    id :number;
    name : IndividualNameViewModel;
    gender: string;
    birthDate: string;
    birthFTDate: FTDate;
    birthPlace : AddressViewModel;
    isAlive : boolean;
    deathDate : string;
    deathFTDate: FTDate;
    deathPlace : AddressViewModel;

    biographical : string;
    isBiographicalSupression: boolean ;
    address: string;
    medical : string;
    isMedicalSupression : boolean;
    phone : string;
    email : string ;
    isSearchSupression : boolean;
    isCalenderSupression : boolean;

    media: MultiMediaBasicInfo[] ;
    selectedMultimediaId: number;
}